module.exports = __webpack_public_path__ + "static/media/chivalry.85bdce6a.png";